import { render } from "./CambioView.vue?vue&type=template&id=50b497ec"
import script from "./CambioView.vue?vue&type=script&lang=js"
export * from "./CambioView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__